export default __webpack_public_path__ + "static/lk-afedc34fb4f09d531f02de66a6bb48f7.svg";